import { DatePipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { ENVIRONMENT } from '../../../../../environments/environment.interface';
import { DisabilityKind } from '../../../../api/app-types/disability-type.app';
import { DOCUMENT_CATEGORY, DocumentFile, DocumentNavItem } from '../../../../api/app-types/document.app';
import { CUSTOM_DATE_FORMATS } from '../../../../core/adapters/custom-date-format';
import { LvrPermissionDirective } from '../../../../shared/permissions/permission.directive';
import { PERMISSION_RESOURCE } from '../../../../shared/permissions/permissions.types';

@Component({
	selector: 'lvr-disability-type-item',
	imports: [TranslocoPipe, LvrPermissionDirective, DatePipe],
	templateUrl: './disability-type-item.html',
	styleUrl: './disability-type-item.scss',
})
export class DisabilityTypeItem {
	public readonly environment = inject(ENVIRONMENT);
	private readonly router = inject(Router, { optional: true });
	public readonly dateDisplayFormat = CUSTOM_DATE_FORMATS.display.dateInput;
	public readonly readPermissions: PERMISSION_RESOURCE[] = ['Clients.Read', 'Clients.Read.PhaseOneOnly'];

	public readonly disabilityType = input<DisabilityKind>();

	public openDocument(event: MouseEvent, file: DocumentFile) {
		if (!this.router) return;

		const clientId = this.resolveClientId();
		if (!clientId) return;

		event.preventDefault();
		event.stopPropagation();

		this.router.navigate(['/desk/client', clientId, 'documents', file.id], {
			state: { navItems: this.buildDisabilityKindNavItems(this.disabilityType()) },
		});
	}

	private resolveClientId(): string | null {
		if (!this.router) return null;

		const match = this.router.url.match(/\/desk\/client\/([^/]+)/);

		return match?.[1] ?? null;
	}

	private buildDisabilityKindNavItems(kind?: DisabilityKind): DocumentNavItem[] {
		if (!kind) return [];

		const files = kind.documents ?? [];
		const entryName = kind.disabilityType?.remark?.trim() || '-';
		const createdAt = kind.statusAsOf ?? new Date();

		return files.map((file) => ({
			file,
			entryId: kind.id,
			entryName,
			category: DOCUMENT_CATEGORY.DISABILITY_KIND,
			createdAt,
			isReport: false,
			isFrozen: false,
		}));
	}
}
